require('./scheduledTransfersContentHeader.scss');

// @ vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @ commons
const { formatText } = require('core/i18n').i18n;
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');


class ScheduledTransfersContentHeader extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
    }

    handleAccountChange(accountId) {
        this.props.history.push(`/myprofile/transfers/scheduled/${accountId}`);
    }

    render() {
        const { immAccounts, isInactiveAccountsEnabled, accountId, onFilterClick } = this.props;
        const headerTitle = formatText('transfersScheduled-from');
        const accountsIndexes = immAccounts.get('byOrder').toJS();
        const tooltipElement = isInactiveAccountsEnabled ? (
            <div className="scheduled-transfers-content-header__tooltip">
                <OKTooltip
                    content="inactiveAccounts-inactiveAccounts_consultiveDropdownCommonToolTip"
                    offset={[0, -15]}
                />
            </div>
        ): '';

        return (
            <header className="scheduled-transfers-content-header">
                <div className="clearfix scheduled-transfers-content-header__title">
                    <div className="pull-left">
                        <OKBoxTitle value={headerTitle} />
                    </div>
                    <div className="pull-right scheduled-transfers-content-header__filters">
                        <OKButton modifier="task" onClick={onFilterClick}>
                            <i className="icon-filtrar scheduled-transfers-content-header__filter-icon" />
                        </OKButton>
                    </div>
                </div>
                <div className="row scheduled-transfers-content-header__dropdown">
                    <div className="col-xs-5-cc-6">
                        <DropdownAccounts
                            immAccounts={immAccounts.get('byId')}
                            accountsIndexes={accountsIndexes}
                            currentAccountId={accountId}
                            initialAccountIndex=""
                            onAccountChange={this.handleAccountChange}
                            showAvailableBalance={true}
                        />
                    </div>
                    {tooltipElement}
                </div>
            </header>
        );
    }
}

ScheduledTransfersContentHeader.propTypes = {
    accountId: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    onFilterClick: PropTypes.func.isRequired
}

module.exports = withRouter(ScheduledTransfersContentHeader);
